<div [formGroup]="configurationFG()" class="flex flex-col gap-4">
  <vx-form-field
    [label]="
      'pages.settings.alerting.processors.create.correlatorTypeField'
        | transloco
    ">
    <vx-radio-group formControlName="correlatorType">
      <vx-radio-group-item
        [value]="correlator.STATISTICAL"
        [label]="
          'pages.settings.alerting.processors.create.correlationMethodField.statistical.label'
            | transloco
        "
        [description]="
          'pages.settings.alerting.processors.create.correlationMethodField.statistical.description'
            | transloco
        " />
      <vx-radio-group-item
        [value]="correlator.ML"
        [label]="
          'pages.settings.alerting.processors.create.correlationMethodField.ml.label'
            | transloco
        "
        [description]="
          'pages.settings.alerting.processors.create.correlationMethodField.ml.description'
            | transloco
        " />
      <vx-radio-group-item
        [value]="correlator.FUSION"
        [label]="
          'pages.settings.alerting.processors.create.correlationMethodField.fusion.label'
            | transloco
        "
        [description]="
          'pages.settings.alerting.processors.create.correlationMethodField.fusion.description'
            | transloco
        "
        [disabled]="true" />
    </vx-radio-group>
  </vx-form-field>

  @if (isStatistical()) {
    <vx-form-field
      [label]="
        'pages.settings.alerting.processors.create.similarityThresholdField'
          | transloco
      "
      [hint]="
        'pages.settings.alerting.processors.create.similarityThresholdInfo'
          | transloco
      ">
      <vx-input
        type="number"
        inputMode="decimal"
        formControlName="similarityThreshold" />
      <ng-template vxFormFieldError="min">
        {{
          'pages.settings.alerting.processors.create.similarityThresholdInvalid'
            | transloco
        }}
      </ng-template>
      <ng-template vxFormFieldError="max">
        {{
          'pages.settings.alerting.processors.create.similarityThresholdInvalid'
            | transloco
        }}
      </ng-template>
    </vx-form-field>

    <vx-form-field
      [label]="
        'pages.settings.alerting.processors.create.weightConfiguration'
          | transloco
      "
      [hint]="
        'pages.settings.alerting.processors.create.weights.hint' | transloco
      ">
      <vx-kv-editor
        formControlName="weights"
        [keyPlaceholder]="
          'pages.settings.alerting.processors.create.weights.keyPlaceholder'
            | transloco
        "
        [valuePlaceholder]="
          'pages.settings.alerting.processors.create.weights.valuePlaceholder'
            | transloco
        "
        [addLabel]="
          'pages.settings.alerting.processors.create.weights.add' | transloco
        "
        [removeLabel]="
          'pages.settings.alerting.processors.create.weights.remove' | transloco
        " />
      <ng-template vxFormFieldError="invalidWeight">
        {{
          'pages.settings.alerting.processors.create.weights.invalid'
            | transloco
        }}
      </ng-template>
    </vx-form-field>
  }
</div>
